module.exports = __webpack_public_path__ + "assets/img/pop-5.8acfdb6a.jpg";